import { RouteConfig } from "vue-router";
import { Network } from "@/network";
import { PermissionCode, DefaultPath } from "@/constant/GroupPermission";

const StoreRoute: Array<RouteConfig> = [
  {
    path: "/store/user/add",
    component: () => import("@/views/ap/store/user/Add.vue"),
    meta: { privKey: { controller: PermissionCode.BankStore, method: PermissionCode.BankStoreUser, type: "add" } },
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) next();
      else next(DefaultPath);
    }
  },
  {
    path: "/store/user/list",
    component: () => import("@/views/ap/store/user/List.vue"),
    meta: { privKey: { controller: PermissionCode.BankStore, method: PermissionCode.BankStoreUser, type: "get" } },
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) next();
      else next(DefaultPath);
    }
  },
  {
    path: "/store/user/edit",
    component: () => import("@/views/ap/store/user/Edit.vue"),
    meta: { privKey: { controller: PermissionCode.BankStore, method: PermissionCode.BankStoreUser, type: "edit" } },
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) next();
      else next(DefaultPath);
    }
  },
];

export { StoreRoute };
